// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Descarga de Evidencias — tabla de SPOA y descargas */

.download-certificates-page.inventory-page {
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

.download-certificates-page .page-header {
  align-items: flex-start;
  flex-shrink: 0;
}

.dc-search-wrap {
  padding: 16px 40px 8px;
  flex-shrink: 0;
}

.dc-search {
  display: flex;
  align-items: center;
  gap: 12px;
  max-width: 720px;
  padding: 10px 14px;
  background: #0a0a0a;
  border: 1px solid #374151;
  border-radius: 10px;
}

.dc-search svg {
  flex-shrink: 0;
  color: #6b7280;
}

.dc-search input {
  flex: 1 1;
  min-width: 0;
  border: none;
  background: transparent;
  color: #fff;
  font-size: 14px;
  outline: none;
}

.dc-search input::placeholder {
  color: #6b7280;
}

.dc-table-section {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  padding: 16px 40px 24px;
  overflow: hidden;
}

/* Solo la lista de registros hace scroll; cabecera de página y búsqueda quedan fijas */
.dc-table-scroll {
  flex: 1 1;
  min-height: 0;
  overflow: auto;
  border: 1px solid #374151;
  border-radius: 10px;
  background: #111;
  -webkit-overflow-scrolling: touch;
}

.dc-table-scroll .dc-table {
  border: none;
  border-radius: 0;
}

.dc-table {
  width: 100%;
  min-width: 560px;
  border-collapse: collapse;
  font-size: 13px;
  background: #111;
  border: 1px solid #374151;
  border-radius: 10px;
  overflow: hidden;
}

.dc-table--compact {
  min-width: 600px;
}

.dc-cell-preview {
  vertical-align: middle;
}

.dc-preview-btns {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
}

.dc-preview-btn {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  padding: 6px 10px;
  font-size: 12px;
  font-weight: 600;
  color: #e5e7eb;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid #374151;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;
  white-space: nowrap;
}

.dc-preview-btn:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.1);
  border-color: #6b7280;
}

.dc-preview-btn--custody:hover:not(:disabled) {
  border-color: #2563eb;
  background: rgba(37, 99, 235, 0.12);
}

.dc-preview-btn:disabled {
  opacity: 0.55;
  cursor: wait;
}

.dc-table thead {
  background: #0a0a0a;
}

.dc-table-scroll .dc-table thead th {
  position: sticky;
  top: 0;
  z-index: 2;
  background: #0a0a0a;
  box-shadow: 0 1px 0 #374151;
}

.dc-table th {
  text-align: left;
  padding: 12px 14px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #9ca3af;
  border-bottom: 1px solid #374151;
}

.dc-th-preview {
  text-align: right;
  width: 1%;
  white-space: nowrap;
  min-width: 120px;
}

.dc-th-download {
  text-align: right;
  width: 1%;
  white-space: nowrap;
}

.dc-table td {
  padding: 14px;
  color: #e5e7eb;
  border-bottom: 1px solid #1f2937;
  vertical-align: middle;
}

.dc-table tbody tr:hover {
  background: rgba(166, 27, 52, 0.06);
}

.dc-table tbody tr:last-child td {
  border-bottom: none;
}

.dc-cell-icon {
  width: 44px;
  text-align: center;
}

.dc-doc-icon {
  display: inline-flex;
  color: #a61b34;
}

.dc-doc-icon--spoa {
  color: #2563eb;
}

.dc-cell-download {
  text-align: right;
}

.dc-download-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 8px 14px;
  font-size: 13px;
  font-weight: 600;
  color: #fecaca;
  background: rgba(166, 27, 52, 0.15);
  border: 1px solid #a61b34;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s, color 0.15s;
}

.dc-download-btn:hover {
  background: rgba(166, 27, 52, 0.28);
  border-color: #dc2626;
  color: #fff;
}

.dc-download-btn:active {
  transform: scale(0.98);
}

.dc-empty {
  padding: 48px 24px;
  text-align: center;
  color: #6b7280;
  font-size: 14px;
  max-width: 640px;
  margin: 0 auto;
  line-height: 1.5;
}

.dc-empty--error .dc-empty-hint {
  margin-top: 12px;
  font-size: 12px;
  color: #9ca3af;
}

.dc-code {
  font-family: ui-monospace, monospace;
  font-size: 11px;
  color: #fca5a5;
}

.dc-retry-btn {
  margin-top: 16px;
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 600;
  color: #fff;
  background: #a61b34;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}

.dc-retry-btn:hover {
  background: #c41e3a;
}

.dc-photo-badge {
  display: inline-block;
  margin-left: 8px;
  padding: 2px 8px;
  font-size: 11px;
  font-weight: 600;
  color: #93c5fd;
  background: rgba(37, 99, 235, 0.15);
  border-radius: 10px;
  vertical-align: middle;
}

.dc-type-tag {
  display: inline-block;
  padding: 3px 10px;
  font-size: 11px;
  font-weight: 700;
  border-radius: 6px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.dc-type-tag--spoa {
  color: #93c5fd;
  background: rgba(37, 99, 235, 0.15);
}

.dc-type-tag--export {
  color: #fca5a5;
  background: rgba(166, 27, 52, 0.15);
}

/* Collapsible SPOA groups */
.dc-spoa-header {
  cursor: pointer;
  background: #0d0d0d;
  -webkit-user-select: none;
          user-select: none;
  transition: background 0.15s;
}

.dc-spoa-header:hover {
  background: #161616;
}

.dc-spoa-header td {
  padding: 12px 14px;
  border-bottom: 1px solid #1f2937;
}

.dc-spoa-header-content {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.dc-spoa-header-icon {
  color: #a61b34;
  flex-shrink: 0;
}

.dc-spoa-header-name {
  font-size: 14px;
  font-weight: 700;
  color: #f3f4f6;
}

.dc-spoa-header-date {
  font-size: 12px;
  color: #6b7280;
}

.dc-spoa-header-count {
  margin-left: auto;
  font-size: 11px;
  font-weight: 600;
  color: #9ca3af;
  background: rgba(255, 255, 255, 0.06);
  padding: 2px 10px;
  border-radius: 10px;
}

.dc-evidence-row {
  background: #111;
}

.dc-evidence-row td:first-child {
  padding-left: 28px;
}

.dc-check-icon {
  color: #10b981;
}

.dc-evidence-camera {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #e5e7eb;
  font-size: 13px;
}

.dc-evidence-camera svg {
  color: #6b7280;
  flex-shrink: 0;
}

.dc-row--spoa {
  border-left: 3px solid #2563eb;
}

.dc-download-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.dc-spin {
  animation: dc-spin-anim 1s linear infinite;
}

@keyframes dc-spin-anim {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* Overlay flujo «Guardar y Descargar» desde Grabaciones */
.dc-spoa-await-overlay {
  position: fixed;
  inset: 0;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(0, 0, 0, 0.82);
  backdrop-filter: blur(4px);
}

.dc-spoa-await-card {
  max-width: 420px;
  padding: 28px 32px;
  text-align: center;
  background: #111827;
  border: 1px solid #374151;
  border-radius: 14px;
  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.45);
}

.dc-spoa-await-loader {
  color: #a61b34;
  margin: 0 auto 16px;
  display: block;
}

.dc-spoa-await-title {
  margin: 0;
  font-size: 17px;
  font-weight: 700;
  color: #f9fafb;
  line-height: 1.35;
}

.dc-spoa-await-sub {
  margin: 12px 0 0;
  font-size: 13px;
  font-weight: 400;
  color: #9ca3af;
  line-height: 1.45;
}

@media (max-width: 768px) {
  .dc-search-wrap,
  .dc-table-section {
    padding-left: 16px;
    padding-right: 16px;
  }

  .dc-download-btn span {
    display: none;
  }

  .dc-download-btn {
    padding: 10px 12px;
  }

  .dc-preview-btn span {
    display: none;
  }

  .dc-preview-btn {
    padding: 8px 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/DownloadCertificatesPage.css"],"names":[],"mappings":"AAAA,uDAAuD;;AAEvD;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,uFAAuF;AACvF;EACE,SAAO;EACP,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qCAAqC;EACrC,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mCAAmC;EACnC,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,6DAA6D;AAC/D;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mCAAmC;EACnC,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA,4BAA4B;AAC5B;EACE,eAAe;EACf,mBAAmB;EACnB,yBAAiB;UAAjB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qCAAqC;EACrC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA,0DAA0D;AAC1D;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE;;IAEE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* Descarga de Evidencias — tabla de SPOA y descargas */\n\n.download-certificates-page.inventory-page {\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.download-certificates-page .page-header {\n  align-items: flex-start;\n  flex-shrink: 0;\n}\n\n.dc-search-wrap {\n  padding: 16px 40px 8px;\n  flex-shrink: 0;\n}\n\n.dc-search {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  max-width: 720px;\n  padding: 10px 14px;\n  background: #0a0a0a;\n  border: 1px solid #374151;\n  border-radius: 10px;\n}\n\n.dc-search svg {\n  flex-shrink: 0;\n  color: #6b7280;\n}\n\n.dc-search input {\n  flex: 1;\n  min-width: 0;\n  border: none;\n  background: transparent;\n  color: #fff;\n  font-size: 14px;\n  outline: none;\n}\n\n.dc-search input::placeholder {\n  color: #6b7280;\n}\n\n.dc-table-section {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  padding: 16px 40px 24px;\n  overflow: hidden;\n}\n\n/* Solo la lista de registros hace scroll; cabecera de página y búsqueda quedan fijas */\n.dc-table-scroll {\n  flex: 1;\n  min-height: 0;\n  overflow: auto;\n  border: 1px solid #374151;\n  border-radius: 10px;\n  background: #111;\n  -webkit-overflow-scrolling: touch;\n}\n\n.dc-table-scroll .dc-table {\n  border: none;\n  border-radius: 0;\n}\n\n.dc-table {\n  width: 100%;\n  min-width: 560px;\n  border-collapse: collapse;\n  font-size: 13px;\n  background: #111;\n  border: 1px solid #374151;\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.dc-table--compact {\n  min-width: 600px;\n}\n\n.dc-cell-preview {\n  vertical-align: middle;\n}\n\n.dc-preview-btns {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 6px;\n}\n\n.dc-preview-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 6px;\n  padding: 6px 10px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #e5e7eb;\n  background: rgba(255, 255, 255, 0.06);\n  border: 1px solid #374151;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background 0.15s, border-color 0.15s;\n  white-space: nowrap;\n}\n\n.dc-preview-btn:hover:not(:disabled) {\n  background: rgba(255, 255, 255, 0.1);\n  border-color: #6b7280;\n}\n\n.dc-preview-btn--custody:hover:not(:disabled) {\n  border-color: #2563eb;\n  background: rgba(37, 99, 235, 0.12);\n}\n\n.dc-preview-btn:disabled {\n  opacity: 0.55;\n  cursor: wait;\n}\n\n.dc-table thead {\n  background: #0a0a0a;\n}\n\n.dc-table-scroll .dc-table thead th {\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  background: #0a0a0a;\n  box-shadow: 0 1px 0 #374151;\n}\n\n.dc-table th {\n  text-align: left;\n  padding: 12px 14px;\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: #9ca3af;\n  border-bottom: 1px solid #374151;\n}\n\n.dc-th-preview {\n  text-align: right;\n  width: 1%;\n  white-space: nowrap;\n  min-width: 120px;\n}\n\n.dc-th-download {\n  text-align: right;\n  width: 1%;\n  white-space: nowrap;\n}\n\n.dc-table td {\n  padding: 14px;\n  color: #e5e7eb;\n  border-bottom: 1px solid #1f2937;\n  vertical-align: middle;\n}\n\n.dc-table tbody tr:hover {\n  background: rgba(166, 27, 52, 0.06);\n}\n\n.dc-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.dc-cell-icon {\n  width: 44px;\n  text-align: center;\n}\n\n.dc-doc-icon {\n  display: inline-flex;\n  color: #a61b34;\n}\n\n.dc-doc-icon--spoa {\n  color: #2563eb;\n}\n\n.dc-cell-download {\n  text-align: right;\n}\n\n.dc-download-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 8px 14px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #fecaca;\n  background: rgba(166, 27, 52, 0.15);\n  border: 1px solid #a61b34;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background 0.15s, border-color 0.15s, color 0.15s;\n}\n\n.dc-download-btn:hover {\n  background: rgba(166, 27, 52, 0.28);\n  border-color: #dc2626;\n  color: #fff;\n}\n\n.dc-download-btn:active {\n  transform: scale(0.98);\n}\n\n.dc-empty {\n  padding: 48px 24px;\n  text-align: center;\n  color: #6b7280;\n  font-size: 14px;\n  max-width: 640px;\n  margin: 0 auto;\n  line-height: 1.5;\n}\n\n.dc-empty--error .dc-empty-hint {\n  margin-top: 12px;\n  font-size: 12px;\n  color: #9ca3af;\n}\n\n.dc-code {\n  font-family: ui-monospace, monospace;\n  font-size: 11px;\n  color: #fca5a5;\n}\n\n.dc-retry-btn {\n  margin-top: 16px;\n  padding: 8px 16px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #fff;\n  background: #a61b34;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n.dc-retry-btn:hover {\n  background: #c41e3a;\n}\n\n.dc-photo-badge {\n  display: inline-block;\n  margin-left: 8px;\n  padding: 2px 8px;\n  font-size: 11px;\n  font-weight: 600;\n  color: #93c5fd;\n  background: rgba(37, 99, 235, 0.15);\n  border-radius: 10px;\n  vertical-align: middle;\n}\n\n.dc-type-tag {\n  display: inline-block;\n  padding: 3px 10px;\n  font-size: 11px;\n  font-weight: 700;\n  border-radius: 6px;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n\n.dc-type-tag--spoa {\n  color: #93c5fd;\n  background: rgba(37, 99, 235, 0.15);\n}\n\n.dc-type-tag--export {\n  color: #fca5a5;\n  background: rgba(166, 27, 52, 0.15);\n}\n\n/* Collapsible SPOA groups */\n.dc-spoa-header {\n  cursor: pointer;\n  background: #0d0d0d;\n  user-select: none;\n  transition: background 0.15s;\n}\n\n.dc-spoa-header:hover {\n  background: #161616;\n}\n\n.dc-spoa-header td {\n  padding: 12px 14px;\n  border-bottom: 1px solid #1f2937;\n}\n\n.dc-spoa-header-content {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.dc-spoa-header-icon {\n  color: #a61b34;\n  flex-shrink: 0;\n}\n\n.dc-spoa-header-name {\n  font-size: 14px;\n  font-weight: 700;\n  color: #f3f4f6;\n}\n\n.dc-spoa-header-date {\n  font-size: 12px;\n  color: #6b7280;\n}\n\n.dc-spoa-header-count {\n  margin-left: auto;\n  font-size: 11px;\n  font-weight: 600;\n  color: #9ca3af;\n  background: rgba(255, 255, 255, 0.06);\n  padding: 2px 10px;\n  border-radius: 10px;\n}\n\n.dc-evidence-row {\n  background: #111;\n}\n\n.dc-evidence-row td:first-child {\n  padding-left: 28px;\n}\n\n.dc-check-icon {\n  color: #10b981;\n}\n\n.dc-evidence-camera {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  color: #e5e7eb;\n  font-size: 13px;\n}\n\n.dc-evidence-camera svg {\n  color: #6b7280;\n  flex-shrink: 0;\n}\n\n.dc-row--spoa {\n  border-left: 3px solid #2563eb;\n}\n\n.dc-download-btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.dc-spin {\n  animation: dc-spin-anim 1s linear infinite;\n}\n\n@keyframes dc-spin-anim {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n/* Overlay flujo «Guardar y Descargar» desde Grabaciones */\n.dc-spoa-await-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 10000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  background: rgba(0, 0, 0, 0.82);\n  backdrop-filter: blur(4px);\n}\n\n.dc-spoa-await-card {\n  max-width: 420px;\n  padding: 28px 32px;\n  text-align: center;\n  background: #111827;\n  border: 1px solid #374151;\n  border-radius: 14px;\n  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.45);\n}\n\n.dc-spoa-await-loader {\n  color: #a61b34;\n  margin: 0 auto 16px;\n  display: block;\n}\n\n.dc-spoa-await-title {\n  margin: 0;\n  font-size: 17px;\n  font-weight: 700;\n  color: #f9fafb;\n  line-height: 1.35;\n}\n\n.dc-spoa-await-sub {\n  margin: 12px 0 0;\n  font-size: 13px;\n  font-weight: 400;\n  color: #9ca3af;\n  line-height: 1.45;\n}\n\n@media (max-width: 768px) {\n  .dc-search-wrap,\n  .dc-table-section {\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n\n  .dc-download-btn span {\n    display: none;\n  }\n\n  .dc-download-btn {\n    padding: 10px 12px;\n  }\n\n  .dc-preview-btn span {\n    display: none;\n  }\n\n  .dc-preview-btn {\n    padding: 8px 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
